<template>
  <div class="inventoryRp">
      <el-dialog
        :title="mainItem ? mainItem.payOrderId+$t('other.a1835') : $t('other.a1836')"
        :visible.sync="dialogVisible"
        width="30%"
        >
        
            <el-table 
                :data="mainItem ? mainItem.orderDeductions : []" 
                border>
                <el-table-column :label="$t('other.a1837')" width="80"  prop="needStock01" :show-overflow-tooltip="true">
                    <template scope="scope" >
                        <span>{{scope.row.orderFee}}</span>
                    </template>
                </el-table-column >
                <el-table-column :label="$t('other.a1838')"  prop="needStock01" :show-overflow-tooltip="true">
                    <template scope="scope" >
                        <span>{{scope.row.desc}}</span>
                    </template>
                </el-table-column >  
                </el-table>
        
        
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">{{$t('other.a5')}}</el-button>
        </span>
      </el-dialog>

      <div class="desc">
          <div class="titleDesc">{{$t('other.a863')}}/{{$t('other.a1839')}}</div>

           <div class="pong">
            <div class="block">
                <el-date-picker
                size="mini"
                v-model="value6"
                value-format="yyyy-MM-dd"
                type="daterange"
                @change="getTime()"
                :range-separator="$t('other.a47')"
                :start-placeholder="$t('other.a45')"
                :end-placeholder="$t('other.a46')">
                </el-date-picker>
            </div>

            <div :class="{'okng':true,'active':dataOfType == 30 }" @click="getDataOfType(30)">{{$t('other.a1823')}}</div>
            <div :class="{'okng':true,'active':dataOfType == 7 }" @click="getDataOfType(7)">{{$t('other.a1824')}}</div>
            <div :class="{'okng':true,'active':dataOfType == 3 }" @click="getDataOfType(3)">{{$t('other.a1825')}}</div>
           
        </div>
         <!-- <div class="itemWrapper">
             
             <div>
                <span :class="{'sokng':true,'active':storeId == item.value}" @click="getData(item,0)" v-for="(item,index) in storeList" :key="index">{{item.label}}</span>
             </div>
         </div> -->
         <div class="itemWrapper">
             <!-- <div class="store">卖家选择</div> -->
             <div>
                <span :class="{'sokng':true,'active':sellerId == item.value}" @click="getData(item,1)" v-for="(item,index) in sellerBtn" :key="index">{{item.label}}</span>
             </div>
         </div>
         <div class="itemWrapper">
             <!-- <div class="store">积分类型</div> -->
             <div>
                <span :class="{'sokng':true,'active':pointType == item.value}" @click="getData(item,2)" v-for="(item,index) in payTypeBtn" :key="index">{{showChange(item.label)}}</span>
             </div>
         </div>
         <div class="remindData">
             <div>
                <span class="store">{{stockReminder}}{{$t('other.a1840')}}</span>
                <!-- <el-select @change="getRecharge()"  v-model="pay_Value" :placeholder="$t('other.a2199')" size="small">
                    <el-option v-for="item in payTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select> -->
                <!-- <span :class="{'sokng':true,'active':type == item.type}"  @click="type = item.type,page = 0" v-for="(item,index) in timeList" :key="index">{{item.label}}<span v-if="item.num > -1">(x{{item.num}})</span></span> -->
                <el-button  type="info" size="medium"  @click="exportXlm()">{{$t('other.a1828')}}</el-button>
                
             </div>
             <div style="display: flex; align-items: center;">
                 <div class="btn">
                    {{$t('other.a591')}}：
                    <el-date-picker
                    size="mini"
                    v-model="value7"
                    value-format="yyyy-MM-dd"
                    @change="getTimeP()"
                    type="daterange"
                    :range-separator="$t('other.a47')"
                    :start-placeholder="$t('other.a45')"
                    :end-placeholder="$t('other.a46')">
                    </el-date-picker>
                </div>
                 <div class="btn">
                    {{$t('other.a764')}}：<el-input size="medium" style="width:350px;margin:0 5px;" @change="getLogByOrderId()" v-model="orderId" :placeholder="$t('other.a764')"></el-input>
                </div>
             </div>
         </div>
      </div>
     
      <div>
          
          <el-table 
					:data="orderList"
                    @sort-change="changeSort"
					ref="multipleTable"
					border>
						<el-table-column :label="$t('other.a1842')"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{showChange(scope.row.payType)}}</span>
                                <!-- <span>{{scope.row.payType}}</span> -->
							</template>
						</el-table-column >
                        <el-table-column :label="$t('other.a60')"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{scope.row.payOrderId}}</span>
							</template>
						</el-table-column >
                        <el-table-column :label="$t('other.a1843')"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{scope.row.changeIntegral}}</span>
							</template>
						</el-table-column >
                        
                        <el-table-column :label="$t('other.a1844')"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{showSellerName(scope.row.payWith)}}</span>
							</template>
						</el-table-column >
                        <el-table-column :label="$t('other.a89')"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{scope.row.createTime}}</span>
							</template>
						</el-table-column >
                        <el-table-column :label="$t('other.a591')"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{scope.row.packagedTime}}</span>
							</template>
						</el-table-column >
                        <el-table-column :label="$t('other.a33')"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<!-- <div><el-button size="mini" type="primary" @click="updataIntegal(scope.row)">更新积分纪录</el-button></div> -->
                                <div><el-button size="mini" type="warning" @click="viewDetail(scope.row)">{{$t('other.a1845')}}</el-button></div>
							</template>
						</el-table-column >
                        <!-- <el-table-column label="扣减详情"  prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<div v-for="(desc,index) in scope.row.logDesc" :key="index">
                                    {{desc}}
                                </div>
							</template>
						</el-table-column > -->
					</el-table>

             <div class="pagination">

                 <el-pagination
                background
                size="mini"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="stockReminder">
                </el-pagination>
             </div>       
      </div>
  </div>
</template>

<script>
import utils from '../../utils/utils'
import deductionApi from '../../api/moudles/deduction'
import userStoreItems from '../../api/moudles/userStoreItems'
import * as echarts from 'echarts';
import { mapState, mapActions, mapMutations} from 'vuex'
export default {
data(){
return{
    radio:false,
    dialogVisible:false,
    dayofship:7,
    remindData:[],
    payTypeBtn:[],
    mainItem:null,
    dataOfType:30,
    storeoperaterecord:[],
    storeItemlist:[],
    storeoperaterecordcount:0,
    cusCode:null,
    pointType:0,
    type:0,
    stockReminder:0,
    outOfstockReminder:[],
    unsalable:[],
    storeList:[],
    orderId:null,
    storeId:0,
    totalAmount:0,
    listData:[],
    sellerId:0,
    userId:null,
    value6:'',
    value7:'',
    page:0,
    userInfo:JSON.parse(localStorage.getItem('userInfo')),
    timeList:[{
        label:this.$t('other.a358'),
        type:0,
        num:-1,
    },{
        label:this.$t('other.a202'),
        type:1,
        num:0
    },{
        label:this.$t('other.a203'),
        type:2,
        num:0
    }],
    pay_Value:null,
    payTypeOptions:[],
    logparams:{
        payType:null,
        offset:10,
        page:0,
        sellerIds: null,
        shopIds:[],
        storeIds:[],
        end:null,
        start:null,
        userId:null,
        startPackagedTime:null,
        endPackagedTime:null
    },
    orderList:[],
    allseller:[]


}
},
computed:{

    logsList(){
        let list=JSON.parse(JSON.stringify(this.orderList))

        let sellerIds=this.logparams.sellerIds
        console.log('sellerIds',sellerIds)
        let payType=this.logparams.payType
        let page=this.logparams.page
        let list2=[]
        let list3=[]
        let list4=[]

        if(this.orderId){
            list.forEach(p => {
                if(p.payOrderId == this.orderId ){
                    list3=[p]
                }
            })
        }else{

            if(sellerIds){
                list.forEach(p => {
                    if(p.sellerUserId == sellerIds ){
                        list2.push(p)
                    }
                })
            }else{
                list2=list
            }
            
            if(payType){
                list2.forEach(p => {
                    if(p.payType == payType){
                        list3.push(p)
                    }
                })
            }else{
                list3=list2
            }
        }

        

        this.stockReminder=list3.length

        list4=list3.splice(page,10)

        console.log('list4',list4)
        return list4

    },

},
created(){
    let partnerId=JSON.parse(localStorage.getItem('userInfo')).partnerId  ? true : false
    console.log('parnetId',partnerId)
    this.payTypeOptions=utils.storePointOption(partnerId)
    this.payTypeBtn=utils.storePointOption(partnerId)
    this.allseller=this.userInfo.sellers
    if(this.allseller){
        this.sellerBtn=this.allseller.map(p => {
            return {
                label:p.userName,
                value:p.userId,
            }
        })
        this.sellerBtn.unshift({
            label:this.$t('other.a1571'),
            value:0,
        })
    }
    this.dataOfType=Number(30)
    let list=[]
    let list2=[]

    for(let i=0;i<this.dataOfType;i++){
        list.unshift(utils.getRecentSevenDay(-i))
        list2.unshift(0)
    }

    this.value6=[list[0],list[list.length-1]]

    this.userId=this.userInfo ? this.userInfo.userId : null 
    this.storeList=utils.getStore()
    this.storeList.unshift({
        label:this.$t('other.a1846'),
        value:0
    })

    this.logparams.userId=this.userId
    this.logparams.orderId=null
    this.logparams.shopIds=null
    this.logparams.storeIds=this.userInfo.storeIds
    this.logparams.end=utils.CurdateAddoneday(this.value6[1])
    this.logparams.start=this.value6[0]
    // this.logparams.endPackagedTime=utils.CurdateAddoneday(this.value7[1])
    // this.logparams.startPackagedTime=this.value7[0]
    this.getPointLog()

    // console.log('storeList',this.storeList)
    // console.log('logparams',this.logparams)
    // this.getStockRemindCopy()

},
methods:{

    ...mapActions('userStoreItems', [
        'getStockRemind',
    ]),

    viewDetail(item){
        this.mainItem=item
        this.dialogVisible=true
    },
    updataIntegal(item){
        console.log(item)
        deductionApi
        .getNewRulesIntegral({
            logIdList:[item.logId],
            userId:this.userId,
        })
        .then(res => {
        if(res.code === 200 ){
            let obj=res.data.success[0]
            let text=obj.orderId +this.$t('other.a1847')
            let desc=this.$t('other.a1848')+obj.payIntegral+this.$t('other.a1849')
            this.$confirm(desc, text, {
            confirmButtonText: this.$t('other.a1850'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
                deductionApi
                .refreshIntegral({
                    logIdList:[item.logId],
                    userId:this.userId,
                })
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                    if(res.data.success.length > 0){
                        this.$message.success(this.$t('other.a1851'))
                    }
                    if(res.data.failed.length>0){
                        this.$message.warning(this.$t('other.a1852'))
                    }
                }else{
                this.$message.warning(res.msg)
                }
                })
            })
        console.log('desc',res.data)
        }else{
        this.$message.warning(res.msg)
        }
        })



        
    },


    getLogByOrderId(){
        if(this.orderId && !this.orderId){
            this.logparams.orderId=null
        }else{
            this.logparams.orderId=this.orderId
        }
        this.getPointLog()
    },

    updataFeeBtn(listCopy){
        let list=[]
        this.payTypeBtn=[]
        listCopy.forEach(p => {
            if(list.indexOf(p.payType) == -1){
                list.push(p.payType)
                this.payTypeBtn.push({
                    value:p.payType,
                    label:p.payType
                })
            }
        })

        this.payTypeBtn.unshift({
            value:0,
            label:this.$t('other.a358')
        })


    },
    
    getPointLog(){
        this.showLoading()
        deductionApi
        .getIntegralLog(this.logparams)
        .then(res => {
            if(res.code === 200) {
                console.log('收入支出',res.data.logs)
                let arr=[35,58,49]
                let listCopy=res.data.logs.filter(p => {
                   
                    if(utils.logFilterByPayType(p.payType,'STORE')){
                        return p
                    }
                })
                console.log(';listCopy',listCopy)
                listCopy.forEach(p => {
                    if(arr.includes(p.payType)){
                        p.payWith=p.sellerUserId
                    }
                    p.createTime=utils.getCurrnetTime(p.createTime)
                    if(p.packagedTime){
                    p.packagedTime=this.TimeTrans(p.packagedTime)
                    }
                    p.logDesc=null
                    if(p.orderDeductions){
                        p.logDesc=p.orderDeductions.map(p => {
                            return  Math.abs(p.orderFee.toFixed(2) )+ "积分--" +p.desc
                        })
                    }
                })
                this.stockReminder=res.data.count
                this.orderList=listCopy
                
               

                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
    TimeTrans(timestamp){
        let date = new Date(new Date(timestamp).getTime() + 8 * 3600 * 1000)
        date = date.toJSON();
        date = date.substring(0, 19).replace('T', ' ')
        return date 
    },

    showChange(id){
        
        let ttp=this.payTypeOptions.find(item => item.value == id)
        if(ttp){
            return ttp.label
        }else{
            return id
        }
    },

    showSellerName(id){
        let ttp=this.allseller.find(item => item.userId == id)
        if(ttp){
            return ttp.userName
        }else{
            return id
        }
    },

    exportXlm(){
        this.showLoading()
        let that=this
        let obj=JSON.parse(JSON.stringify(this.logparams))
        obj.offset=this.stockReminder+5
        deductionApi
        .getIntegralLog(obj)
        .then(res => {
            if(res.code === 200) {
                console.log('收入支出',res.data)
                let list=res.data.logs
                let arr=[]
                list.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime)
                    if(p.packagedTime){
                        p.packagedTime=that.TimeTrans(p.packagedTime)
                    }
                    p.desc=[]
                    if(p.orderDeductions){

                        p.orderDeductions.forEach(i => {
                             p.desc.push('/' +i.orderFee + '积分，' + i.desc + '/')
                        })
                    }
                    arr.push({
                        '费用类型':that.showChange(p.payType),
                        '订单号':p.payOrderId,
                        '积分变化':p.changeIntegral,
                        '可用积分':p.newIntegral,
                        '支付来源':that.showSellerName(p.payWith),
                        '时间':p.createTime,
                        '出库时间':p.packagedTime?this.TimeTrans(p.packagedTime):p.packagedTime,
                        '扣减明细':p.desc.join('&'),
                        
                    })
                })
                console.log('arr',arr)

                let list2=['费用类型','订单号','积分变化','可用积分','支付来源','时间','出库时间','扣减明细']

                utils.exPortEXml(arr,list2,list2)
                console.log('list',list)
              
            }else{
                this.$message.warning(res.msg)
            }
        })


       
    },

    changeSort(val){
        console.log('jkdfn',val)
         if(this.type == 0){
            let list=JSON.parse(JSON.stringify(this.remindData))

             this.sortOrderData(list,val.order,val.prop)
            
        }else if(this.type == 1){
            let list=JSON.parse(JSON.stringify(this.outOfstockReminder))
            this.sortOrderData(list,val.order,val.prop)
            
        }else{
            let list=JSON.parse(JSON.stringify(this.unsalable))
            this.sortOrderData(list,val.order,val.prop)
        }
    },

    sortOrderData(arr,order=null,type){
        let list=arr
        if(order == 'ascending'){
            arr.sort((a,b) => {
                return a[type]-b[type]
            })
        }else if(order == 'descending'){
            arr.sort((a,b) => {
                return b[type]-a[type]
            })
        }

        if(this.type ==0 ){
            this.remindData=arr
        }else if(this.type == 1){
            this.outOfstockReminder=arr
        }else{
            this.unsalable=arr
        }
    },



    getTime(){
        console.log(this.value6)
        this.logparams.end=utils.CurdateAddoneday(this.value6[1])
        this.logparams.start=this.value6[0]
        this.getPointLog()
    },
    getTimeP(){
        console.log(this.value7)
    this.logparams.endPackagedTime=this.value7?utils.CurdateAddoneday(this.value7[1]):null
    this.logparams.startPackagedTime=this.value7?this.value7[0]:null
    if(this.pointType != 0&&this.pointType != 5){
                this.value7 = ''
                this.logparams.startPackagedTime = null
                this.logparams.endPackagedTime = null
            }
        this.getPointLog()
    },

    getDataOfType(num){
        
        this.dataOfType=Number(num)
        let list=[]
        let list2=[]

        for(let i=0;i<this.dataOfType;i++){
            list.unshift(utils.getRecentSevenDay(-i))
            list2.unshift(0)
        }

        this.value6=[list[0],list[list.length-1]]
        this.logparams.end=utils.CurdateAddoneday(this.value6[1])
        this.logparams.start=this.value6[0]
    this.logparams.endPackagedTime=this.value7?utils.CurdateAddoneday(this.value7[1]):null
    this.logparams.startPackagedTime=this.value7?this.value7[0]:null
    if(this.pointType != 0&&this.pointType != 5){
                this.value7 = ''
                this.logparams.startPackagedTime = null
                this.logparams.endPackagedTime = null
            }
        this.getPointLog()
    },

    viewSales(item){
    console.log('item',item)
    this.dialogVisible=true
    this.mainItem=item
 
    },

    lgnk(item,start=null,end=null){
        let that=this
        var chartDom = document.querySelector('#main')
        var myChart = echarts.init(chartDom);
        let params={
            cusCode:item.cusCode,
            end:end ? utils.CurdateAddoneday(end) : utils.CurdateAddoneday(utils.getRecentDays(0)),
            start: start ? start : utils.getRecentDays(-30),
            offset:50,
            type:1,
            page:0,
            userId:this.userId
        }
        
        userStoreItems
		.getInstockoperaterecore(params)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库库存操作日志',res.data)
                let mapList=new Map()
                this.totalAmount=0
               
                res.data.logs.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime).slice(0,10)
                    p.decStock=Math.abs(p.decStock)
                   
                    
                    

                    let list=mapList.get(p.createTime)
                    if(!list || list == null || list == 'undefined'){
                        list={
                            outStock:0,
                            inStock:0,
                            returnStock:0
                        }
                    }
                    
                    if(p.type == 1 ){//出库扣减
                        
                        list.outStock+=p.decStock
                    }else if(p.type == 2){//入库单增加
                        list.inStock+=p.decStock
                    }else if(p.type == 3 ){//退货
                        list.returnStock+=p.decStock
                    }

                    mapList.set(p.createTime,list)

                })

                
                that.option.xAxis.data.forEach((p,index) => {
                    let ttp=mapList.get(p)
                    if(ttp){
                        that.option.series[0].data[index]=ttp.outStock
                        this.totalAmount+=ttp.outStock
                    }
                })
                console.log('mapList',mapList)
                console.log('that.option',that.option)
                that.option && myChart.setOption(that.option);
				
                
			}
		})
    },

    getData(item,num){
        console.log('remindData',this.remindData)
        if(num == 0){
            this.storeId = item.value
            this.logparams.storeIds=item.value == 0 ? null : [item.value] 
        }else if(num == 1){
            console.log(item)
            let sellers=this.userInfo.sellers.find(k => k.userId == item.value)
            this.sellerId=item.value
            this.logparams.sellerIds=item.value == 0 ? null : [item.value]
            // this.logparams.shopIds=sellers ? sellers.shopIds : []
        }else if(num == 2){
            this.pointType=item.value
            this.logparams.payType=item.value == 0 ? null : item.value
            if(this.pointType != 0&&this.pointType != 5){
                this.value7 = ''
                this.logparams.startPackagedTime = null
                this.logparams.endPackagedTime = null
            }
        }

        console.log('logparams',this.logparams)
        this.getPointLog()
        
       
    },

    getRecharge(){
        this.logparams.payType=this.pay_Value
        this.getPointLog()
    },

    upataOutOfStack(data){
        console.log(data)
        let arr=this.remindData.filter(p => {
            p.dayOfShip=Number(data.dayOfShip)
            p.salesAvg01=Number(p.salesAvg.toFixed(2))
            p.needStock01= data.type ? p.dayOfShip*2*p.salesAvg01-p.nowStock-p.shippedStock : p.dayOfShip*2*p.salesAvg01-p.nowStock
            return p
        })
        let list = arr.filter(p => {
            if( p.storeItem.storeId == this.storeId && p.needStock01> 0){
                return p
            }
        })
        console.log('arr',arr)

        list.forEach(i => {
            i.needStock01=Math.ceil(i.needStock01)
            i.salesAvg01=Math.ceil(i.salesAvg01)
        })
        console.log('list',list)
        this.outOfstockReminder=list
        this.timeList[1].num=list.length

       

        

     
        
    },

    handleCurrentChange(val){
        console.log(val)
        this.logparams.page=Number(val-1)*10

        this.getPointLog()
        
    },

    fuzzyMatch(str, key) {
        
       
        str == null ? '' : str
        if(typeof(str) == Number) {
            return str==key
        }

        console.log(typeof(key))

        if(typeof(key) == 'string' && str) {
            console.log(str,key,key.indexOf(str))
            let ttp=false
            if(key.indexOf(str) > -1 || str == key){
                ttp=true
            }
            return ttp
        }else {
            return false;
        }
        
       
    },

    getStockRemindCopy(){
				new Promise((resolve,reject) => {
                let that=this
				this.getStockRemind({userId:this.userId,storeId:this.storeId}).then(res => {
					console.log('852',res)
						if(res.code == 200) {
                            this.originRemindOrder=res.data
							this.remindData=res.data.filter(p => {
                                p.lastTime=p.lastTime ? utils.getCurrnetTime(p.lastTime) : this.$t("other.a354")
                                p.salesAvgMonthly=p.salesAvgMonthly.toFixed(2)
                                p.goodsValue=p.storeItem.storeNum*p.storeItem.cost
                                if(p.storeItem.storeId == this.storeId){
                                    return p
                                }
                            })

                            console.log('remindData',this.remindData)

							this.unsalable=this.remindData.filter(k => {
								if(k.unsalable){
									return k
								}
							})
                            this.timeList[0].num=this.remindData.length

							console.log('unsalable',this.unsalable)
                            this.timeList[2].num=this.unsalable.length
							let arr=this.remindData.filter(p => {
								p.salesAvg01=Number(p.salesAvg.toFixed(2))
								p.needStock01=p.dayOfShip*2*p.salesAvg01-p.nowStock
								return p
							})
                            console.log('arr',arr)
							let list = arr.filter(p => {
								if( p.storeItem.storeId == that.storeId && p.needStock01> 0){
									return p
								}
							})
                            console.log('list1112',list)
							resolve(list)
						}
					})
				}).then(res => {
					res.forEach(i => {
						i.needStock01=Math.ceil(i.needStock01)
						i.salesAvg01=Math.ceil(i.salesAvg01)
					})
					this.outOfstockReminderAmont=res.length
					this.outOfstockReminder=res
                    this.timeList[1].num=res.length
					console.log('缺货提醒11',res)
				})
			},

}
}

</script>
<style lang='scss' scoped>
.inventoryRp{
    background-color: white;
    margin: 20px 15px;
    padding: 10px;
    border-radius: 5px;

    .pong{
        display: flex;

        .okng{
            font-size: 14px;
            color: #919099;
            cursor: pointer;
            margin-left: 30px;
            margin-bottom: 15px;
            padding: 3px 10px;
            border-radius: 3px;
        }

        .active{
            background-color: #66b1ff;
            padding: 3px 10px;
            border-radius: 3px;
            color: #fff;
        }
    }

    .iknkg{
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: center;
    }

    .remindData{
       display: flex;
       margin-top: 30px;
       justify-content: space-between;

        .btn{
            text-align: right;
            margin-bottom:10px;
        }
    }

    .itemWrapper{
        display: flex;
        margin-bottom: 5px;
    }



    .sokng{
        display: inline-block;
        min-width: 70px;
        text-align: center;
        margin: 0 10px;
        cursor: pointer;
        color: #919099;
        padding: 3px ;
        margin: 3px 5px 10px 3px;
         
    }

    .store{
        
        margin-right:30px ;
        box-sizing: border-box;
        padding-top:5px;
        color: #919099;
        width: 120px;;
    }

    .uykpg{
        width: 90px;
        margin-left:30px ;
        margin-right:30px ;
        box-sizing: border-box;
        padding-top:5px;
        color: #0d79f5;
        cursor: pointer;
    }
    .desc{
        width: 100%;

        .titleDesc{
            font-weight: bold;
            color: #616066;
            margin-bottom:30px;
            padding:0px 10px;
            font-size: 25px;
            text-align: center;
        }

    }

    .active{
        color: #fff;
        background-color: #66b1ff;
        padding: 3px ;
        border-radius: 3px;
    }

    .pagination{
        text-align: right;
        margin-top: 18px;
        margin-right: 30 ;
    }

}
</style>